// GetNotifications gets all notifications from CRM for the requesting user
export const NotificationCenterService_GetNotificationsLazy = () =>
  import("./service.grpc").then(
    (m) => m.NotificationCenterService_GetNotifications
  );
NotificationCenterService_GetNotificationsLazy.method =
  "aysa_api.services.notification_center.v1.NotificationCenterService/GetNotifications" as const;

// GetNotificationsV2 gets all notifications
export const NotificationCenterService_GetNotificationsV2Lazy = () =>
  import("./service.grpc").then(
    (m) => m.NotificationCenterService_GetNotificationsV2
  );
NotificationCenterService_GetNotificationsV2Lazy.method =
  "aysa_api.services.notification_center.v1.NotificationCenterService/GetNotificationsV2" as const;
